module.exports = __webpack_public_path__ + "static/media/filter-icon-pressed.29756bf2.svg";